//

import DiagramWrapper from "@/components/Diagram/DiagramWrapper/DiagramWrapper.vue";
import PluginContainer from "@/components/Diagram/PluginContainer/PluginContainer.vue";
import PluginSidebar from "@/components/Diagram/PluginSidebar/PluginSidebar.vue";
import CollapsableContainer from "@/components/Diagram/CollapsableContainer/CollapsableContainer.vue";
import AQButton from "@/components/Generics/AQButton/AQButton";
import AQDialog from "@/components/Generics/AQDialog/AQDialog";
import ScEditAddFunction from "@/components/SmartContractDesigner/SCFunctionsHandler/SCEditAddFunction/SCEditAddFunction";
import SmartContractSidebarHandler from "@/components/SmartContractDesigner/sidebar/SmartContractSidebarHandler/SmartContractSidebarHandler.vue";
import { SMART_CONTRACT_TYPES } from "@/components/SmartContractDesigner/smartContractPluginIDs.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal";
import SCFunctionCodePreview from "@/components/SmartContractDesigner/SCFunctionCodePreview/SCFunctionCodePreview.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import { keyboard } from "../../../../assets/js/Diagram/diagram/models/keycodes.enum";
import { SMART_CONTRACT_PLUGINS } from "../../../../components/Diagram/const/DefaultPlugins";

export default {
    name: "SmartContract",

    components: {
        DiagramWrapper,
        PluginContainer,
        PluginSidebar,
        AQDialog,
        CollapsableContainer,
        SmartContractSidebarHandler,
        AQButton,
        ScEditAddFunction,
        SCFunctionCodePreview,
        AQModal,
        AQDropdown
    },
    data() {
        return {
            retrievedData: false,
            pageName: "Smart Contract Designer",
            displayFabricModal: false,
            currentlyDisplayedModal: null,
            registeredDiagramListener: false,
            dataToSend: null,
            scFunctions: null,
            currentContract: null,
            currentFunction: null,
            functId: null,
            ddlTypeSelector: null,
            isDisabledBtn: false,
            displayCodePreview: false,
            functionLoadStorage: null,
            contractLoadStorage: null,
            titleDialog: "",
            oneUser: true,
            disabled: false,
            messageTitle: "",
            openDialog: false,
            initialDataFunction: null,
            ObjectToChange: null,
            action: null,
            hasSave: { label: this.$t("apps.copyBtn") },
            pluginsToIgnore: [
                SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN,
                SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN
            ],
            readonly: false,
            editfunctionModal: false,
            lastInitializedDiagramDataFor: null,
            openErrorDialog: false,
            dialogMessageError: "",
            defaultValueSelect: "",
            selectvmodel: [],
            functionEditMode: true
        };
    },
    computed: {
        ...mapGetters("smartContractDesigner", [
            "smartContractPluginCategories",
            "selectedPluginCode",
            "selectedPluginUuid",
            "hasSelectedFunction",
            "inEditFunction",
            "applicationFunctions",
            "diagramData",
            "smartContractValidationModel",
            "redoCache",
            "staticVariables"
        ]),
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("main", ["interfaceDirty"]),

        getNoInEditFunctionTitle() {
            return this.inEditFunction
                ? this.$t("smartContract.main.noFunctionSelected")
                : this.$t("smartContract.main.noFunctionsMain");
        },
        displayFunctionsHandler() {
            return (
                this.displayFabricModal && this.currentlyDisplayedModal === "MANAGE"
            );
        },
        diagramDataModel: {
            get() {
                return this.inEditFunction ? this.inEditFunction.diagramData : {};
            },
            set(data) {
                if (data && (data.content || data.connectors)) {
                    this.$store.commit("smartContractDesigner/setDiagramData", data);
                    this.$store.commit("smartContractDesigner/setSaveDigramaData", false);
                }
            }
        },
        config() {
            return { readonly: false };
        },
        smartContractPlugins() {
            return SMART_CONTRACT_PLUGINS;
        },
        create() {
            return { label: this.$t("smartContract.editBtn"), disabled: this.isDisabledBtn };
        }
    },
    watch: {
        $route: "fetchData",
        inEditFunction(val) {
            if (!this.registeredDiagramListener && this.$refs.diagram) {
                this.registerDiagramEventListener();
                window.dispatchEvent(new Event("resize"));
            }
            window.localStorage.setItem("funtionInEdit", JSON.stringify(val));
        },
        oneUser: {
            handler(value) {
                this.disabled = !value;
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions("diagrams", ["getModelForProcessDefinition"]),
        ...mapActions("smartContractDesigner", [
            "getFunctionsForApp",
            "getNewFunctionModel",
            "getFunctionsSignatures",
            "createSmartContractValidationModel",
            "getFunctionById",
            "saveFunctionContract",
            "deleteApplicationFunction",
            "getStaticVariables",
            "getContractsSameNetwork",
            "getScTypes",
            "getEvents"
        ]),
        ...mapMutations("smartContractDesigner", ["setRedoCache"]),
        keyUpHappened(payload) {
            if (payload.ctrlKey && payload.keyCode === keyboard.KEY_Z) {
                this.$refs.diagram.undoState();
            } else if (payload.ctrlKey && payload.keyCode === keyboard.KEY_Y) {
                this.$refs.diagram.redoState();
            }
        },
        scFunctionList() {
            return this.scFunctions.map(fnc => ({
                label: fnc.name,
                value: fnc.id
            }));
        },
        checkDiagramData() {
            if (this.dataToSend && !this.dataToSend.diagramData) {
                const dData = {
                    connectors: [],
                    content: [],
                    gridView: {
                        padding: 500, cellWidth: 100, cellHeight: 100, rows: 12, cols: 10
                    }, //  o sa se puna in momentul in care o sa se adauge si partea de diagrama
                    worldData: { width: 2000, height: 2200 }
                };
                Object.assign(this.dataToSend, { diagramData: JSON.stringify(dData) });
            }
        },
        setupDiagram() {
            if (!this.dataToSend && this.functionLoadStorage) {
                const jsonToObject = JSON.parse(this.functionLoadStorage);
                this.dataToSend = jsonToObject;
                this.$store.commit("smartContractDesigner/setInEditFunction", jsonToObject);
            } else {
                this.$store.commit("smartContractDesigner/setInEditFunction", this.dataToSend);
            }
            this.retrievedData = true;
            this.$store.commit("smartContractDesigner/setApplicationFunctions", this.scFunctions);
            this.checkDiagramData();
            this.$refs.diagram.changeDataSet(this.dataToSend.diagramData);
        },

        fetchData(fromMounted) {
            if (
                !this.retrievedData
        && this.$route.name === "smartContractDesigner"
        && this.currentApp
        && Object.keys(this.currentApp).length > 0
            ) {
                this.getFunctionsForApp().then(data => {
                    this.retrievedData = true;
                    if (data[0]) {
                        this.$store.commit(
                            "smartContractDesigner/setInEditFunction",
                            data[0]
                        );
                        this.checkPermissions();
                    } else if (fromMounted) {
                        this.getNewFunctionModel().then(data => {
                            this.$refs.diagram.changeDataSet(data.diagramData);
                            this.checkPermissions();
                        });
                    }
                });
                this.getFunctionsSignatures(this.currentApp);
                this.getModelForProcessDefinition();
            } else {
                this.retrievedData = false;
            }
        },
        deleteFunctionNode(event) {
            this.$store.commit(
                "smartContractDesigner/removeNode",
                event.payload.PLUGIN_UUID
            );
        },
        selectPlugin(plugin) {
            const self = this;
            setTimeout(() => {
                self.$store.commit("smartContractDesigner/setSelectedPlugin", {
                    PLUGIN_UUID: plugin ? plugin.uuid : plugin,
                    PLUGIN_ID: plugin ? plugin.id : plugin
                });
                self.$refs.diagram.selectPlugin(plugin ? plugin.uuid : plugin);
            }, 50);
        },
        registerDiagramEventListener() {
            const vm = this;
            this.registeredDiagramListener = true;
            this.$refs.diagram.$on("FABRIC_DIAGRAM_EVENT", data => {
                if (data.type === "PLUGIN_SELECTED") {
                    // TODO: Fix diagram to emit the select event after the plugin_created event is throwed.
                    const self = this;
                    setTimeout(() => {
                        if (data.payload.PLUGIN_UUID && data.payload.PLUGIN_ID) {
                            self.$store.commit(
                                "smartContractDesigner/setSelectedPlugin",
                                data.payload
                            );
                        }
                    }, 30);
                } else if (data.type === "PLUGIN_DELETED") {
                    this.deleteFunctionNode(data);
                } else if (
                    data.type === "MULTIPLE_ACTIONS_HAPPENED"
          && data.payload.find(event => event.event === "PLUGIN_DELETED")
                ) {
                    this.deleteFunctionNode(
                        data.payload.find(event => event.event === "PLUGIN_DELETED")
                    );
                } else if (data.type === "PLUGIN_CREATED") {
                    const cacheData = this.redoCache[data.payload.PLUGIN_UUID];
                    const mutationData = {
                        ...data.payload,
                        functionUuid: this.inEditFunction.id
                    };
                    if (cacheData) {
                        mutationData.cacheData = cacheData;
                    }
                    vm.$store.commit("smartContractDesigner/addNode", mutationData);
                } else if (data.type === "CONNECTOR_DELETED") {
                } else if (data.type === "CONNECTOR_CREATED") {
                } else if (data.type === "PLUGIN_LABEL_UPDATED") {
                } else if (data.type === "CONNECTOR_LABEL_UPDATED") {
                }
                if (data.type !== "PLUGIN_SELECTED") {
                    this.$store.commit("main/setInterfaceDirty", true);
                }
            });
        },
        checkPermissions(oneAtATimeParams) {
            const isReadonly = this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
            if (isReadonly) {
                this.readonly = isReadonly;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                this.$refs.diagram.setReadonly(this.readonly, true);
            } else if (oneAtATimeParams && oneAtATimeParams.hasOwnProperty("readonly")) {
                this.readonly = oneAtATimeParams.readonly;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                this.$refs.diagram.setReadonly(this.readonly, this.readonly);
                this.oneUser = !this.readonly;
            } else {
                this.readonly = isReadonly;
                this.$store.commit("main/setSaveBtnVisible", this.readonly);
                if (this.$refs.diagram) {
                    this.$refs.diagram.setReadonly(this.readonly);
                }
            }
        },
        checkParamsNameDuplicates(value) {
            let paramsArray = []; let isDuplicate = false; let
                declareList = [];
            if (value && value.inParameters && value.outParameters) {
                paramsArray = value.inParameters.concat(value.outParameters);
            }
            if (value && value.body) {
                declareList = value.body.filter(fnc => fnc.nodeType === "DECLARE");
            }
            if (paramsArray && paramsArray.length) {
                const mappedArray = paramsArray.map(elem => elem.name);
                isDuplicate = mappedArray.some((elem, index) => mappedArray.indexOf(elem) != index);

                if (!isDuplicate && declareList && declareList.length) {
                    const concatDeclaredVar = [];
                    declareList.forEach(el => {
                        for (let i = 0; i < el.declareList.length; i++) {
                            concatDeclaredVar.push(el.declareList[i]);
                        }
                    });
                    if (concatDeclaredVar && concatDeclaredVar.length) {
                        for (let k = 0; k < concatDeclaredVar.length; k++) {
                            if (concatDeclaredVar[k].variable) {
                                isDuplicate = mappedArray.includes(concatDeclaredVar[k].variable);
                            }
                            if (isDuplicate) {
                                break;
                            }
                        }
                    }
                }
                if (isDuplicate) {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("smartContract.manageFunctions.duplicateParams")
                    });
                }
            }
            return isDuplicate;
        },
        dataForFunction(value) {
            if (value.name && value.functionTypeDto) {
                this.isDisabledBtn = false;
            }
        },

        actionModalFunction(action) {
            if (action === "primary") {
                const data = this.$refs.editAddHandler.getMutableData();
                data.body = this.initialDataFunction.body;
                data.diagramData = this.initialDataFunction.diagramData;
                if (!this.checkParamsNameDuplicates(data) && data.name) {
                    this.saveFunctionContract(data).then(result => {
                        window.localStorage.setItem("funtionInEdit", JSON.stringify(data));
                        this.initialDataFunction = { ...data };
                        data.body = this.inEditFunction.body;
                        data.diagramData = this.inEditFunction.diagramData;
                        data.diagramDataModel = this.inEditFunction.diagramData;
                        this.$store.commit("smartContractDesigner/setInEditFunction", data);
                        this.$store.commit("smartContractDesigner/setSaveDigramaData", false);
                        this.isDisabledBtn = false;
                        for (let i = 0; i < this.scFunctions.length; i++) {
                            if (this.scFunctions[i].id === data.id) {
                                this.scFunctions[i] = data;
                                break;
                            }
                        }
                        this.editfunctionModal = false;
                        this.scFunctionList();
                    }).catch(() => { });
                }
            } else if (action === "close") {
                if (!this.isDisabledBtn) {
                    this.titleDialog = this.$t("documents.wrnTitle");
                    this.messageTitle = this.$t("smartContract.confirmationDialog.msg");
                    this.openDialog = true;
                    this.action = "closeModalFunction";
                } else {
                    this.isDisabledBtn = false;
                    this.editfunctionModal = false;
                }
            }
        },
        editFunction() {
            if (this.oneUser) {
                this.editfunctionModal = true;
                this.isDisabledBtn = true;
                if (this.inEditFunction) {
                    this.dataToSend = this.inEditFunction;
                    this.functId = this.dataToSend.id;
                }
            }
        },

        previewFunction() {
            if (this.oneUser) {
                this.dataToSend = this.inEditFunction;
                this.displayCodePreview = true;
            }
        },
        toSC(breadcrumb) {
            if (breadcrumb === "current") {
                this.$router.push({ name: "smartContractList", params: { contract: this.currentContract } });
            } else {
                this.$router.push({ name: "smartContractList" });
            }
        },
        selectedFunction(val) {
            if (this.interfaceDirty) {
                this.titleDialog = this.$t("documents.wrnTitle");
                this.messageTitle = this.$t("documents.wrnMessage");
                this.openDialog = true;
                this.action = "changeFunction";
                this.ObjectToChange = val;
            } else {
                this.getFunctionById(this.selectvmodel[0].value).then(val => {
                    this.$store.commit("smartContractDesigner/setInEditFunction", val);
                    this.$refs.diagram.changeDataSet(val.diagramData);
                    this.initialDataFunction = val;
                    this.getContractsSameNetwork();
                    window.localStorage.setItem("funtionInEdit", JSON.stringify(val));
                    this.$oneAtATime.destroyCurrentRoom();
                    this.$oneAtATime.createRoom("smartContractDesigner", val.id);
                });
                this.$emit("pluginSelected", null);
            }
        },
        actionModalPreview(action) {
            if (action === "save") {
                navigator.clipboard
                    .writeText(this.previewCode)
                    .then(() => {
                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("apps.successCopy"),
                            timeout: 500
                        });
                    })
                    .catch(e => {
                        this.$toast.showNotify({
                            type: "warning",
                            message: this.$t("apps.errorCopy"),
                            timeout: 500
                        });
                    });
            }
            if (action === "close") {
                this.displayCodePreview = false;
            }
        },

        previewCodeModel(value) {
            this.previewCode = value;
        },

        deleteFunction() {
            if (this.oneUser) {
                this.titleDialog = this.$t("smartContract.removeTitleFunction");
                this.messageTitle = this.$t("smartContract.dialogBodyDefaultFunction");
                this.openDialog = true;
                this.action = "delete";
            }
        },
        okAction() {
            if (this.action === "delete") {
                this.deleteApplicationFunction(this.functId).then(() => {
                    this.$router.push({ name: "smartContractList", params: { contract: this.currentContract } });
                });
            } else if (this.action === "changeFunction") {
                this.getFunctionById(this.ObjectToChange).then(val => {
                    this.$store.commit("smartContractDesigner/setInEditFunction", val);
                    this.$refs.diagram.changeDataSet(val.diagramData);
                    this.initialDataFunction = val;
                    this.getContractsSameNetwork();
                });
                this.$emit("pluginSelected", null);
                this.$store.commit("main/setInterfaceDirty", false);
            } else if (this.action === "closeModalFunction") {
                this.editfunctionModal = false;
            } else {
                this.openDialog = false;
            }
        },
        cancelAction() {
            this.openDialog = false;
        },

        parseContract(contract, funct) {
            if (contract && contract.objectForFunction) {
                this.initialDataFunction = { ...contract.objectForFunction.function };
                this.defaultValueSelect = this.initialDataFunction.id;
                this.scFunctions = contract.objectForFunction.contract.functionPaginationDtoList.function;
                if (this.staticVariables && !this.staticVariables.length) {
                    this.getStaticVariables(contract.objectForFunction.contract.bcType.id);
                }

                if (funct) {
                    this.dataToSend = funct;
                    for (let i = 0; i < this.scFunctions.length; i++) {
                        if (this.scFunctions[i].id === funct.id) {
                            this.scFunctions[i] = funct;
                        }
                    }
                } else {
                    this.dataToSend = contract.objectForFunction.function;
                }
                if (contract.objectForFunction.contract && contract.objectForFunction.contract.bcType) {
                    const indexParent = this.smartContractPluginCategories.findIndex(i => i.title === "Actions");
                    const indexChild = this.smartContractPluginCategories[indexParent].plugins.findIndex(j => j.id === "SMART_CONTRACT_EMIT_EVENT");
                    this.smartContractPluginCategories[indexParent].plugins[indexChild].disabled = !contract.objectForFunction.contract.bcType.supportEvents;
                }
                this.functId = funct && funct.id ? funct.id : contract.objectForFunction.function.id;
                this.ddlTypeSelector = contract.objectForFunction.ddl;
                this.currentContract = contract.objectForFunction.contract;
                this.currentFunction = contract.objectForFunction.function;
                this.$store.commit("smartContractDesigner/setCurrentContract", contract.objectForFunction.contract);
            }
        }
    },

    created() {
        this.getScTypes();
        this.readonly = this.$route.params && this.$route.params.permissions ? this.$route.params.permissions.readonly : null;
        this.$root.$on("oneAtATime-smartContractDesigner", () => {
            if (this.readonly && this.$oneAtATime.state.$currentRoomEmpty) {
                this.retrievedData = false;
            }
            this.readonly = !this.$oneAtATime.state.$currentRoomEmpty;

            this.$refs.diagram.setReadonly(this.readonly);

            this.checkPermissions({ readonly: !this.$oneAtATime.state.$currentRoomEmpty });
        });
        if (this.$route.params && this.$route.params.objectForFunction) {
            this.parseContract(this.$route.params);
            window.localStorage.setItem("contractInEdit", JSON.stringify(this.$route.params));
        }
        if (this.$route.params && this.$route.params.permissions) {
            this.checkPermissions();
        }
    },
    mounted() {
        if (window.localStorage && !this.currentFunction && !this.currentContract) {
            this.functionLoadStorage = JSON.parse(window.localStorage.getItem("funtionInEdit"));
            this.contractLoadStorage = JSON.parse(window.localStorage.getItem("contractInEdit"));
            if (this.functionLoadStorage) {
                this.contractLoadStorage.objectForFunction.function = this.functionLoadStorage;
            }
            this.parseContract(this.contractLoadStorage, this.functionLoadStorage);
        }
        setTimeout(() => {
            this.setupDiagram();
            this.getContractsSameNetwork();
            this.getEvents();
        }, 0);
        if (
            !this.currentApp
      || (this.currentApp && Object.keys(this.currentApp).length === 0)
        ) {
            this.$router.replace("/applications");
        }
        if (!this.registeredDiagramListener && this.$refs.diagram) {
            this.registerDiagramEventListener();
        }
    },
    destroyed() {
        this.retrievedData = false;
    }
};
